import angular from 'angular';
import { HistoricoGeracaoController } from './historico-geracao.controller';

export class HistoricoGeracaoComponent implements angular.IComponentOptions {
    static selector = 'historicoGeracaoComponent';
    static controller = HistoricoGeracaoController;
    static template = require('!!html-loader!./historico-geracao.html');
    static bindings = {
        opened: '<',
        items: '<',
        loading: '<',
        loadError: '<',
        subtitle: '<',
        badgeLabel: '<',
        badgeClass: '<',
        onClose: '&?',
    };
}
